export interface ChapterBlock {
  subtitle: string
  items: string[]
}

export interface Chapter {
  label: string
  kicker: string
  title: string
  description: string
  blocks?: ChapterBlock[]
  note?: string
}

export const chapters: Chapter[] = [
  {
    label: 'Capítulos 1-2',
    kicker: 'El diagnóstico',
    title: 'Escáner de Inflamación y Biología del Secuestro',
    description:
      'Identificas con precisión qué parte de tu volumen es agua, qué parte es inflamación real y qué está disparando tu cortisol cada día. No es adivinanza; es ciencia.',
  },
  {
    label: 'Capítulo 3',
    kicker: 'El hackeo matutino',
    title: 'El Despertar Metabólico (La Tríada de Poder)',
    description:
      'Los primeros 30 minutos de tu día dictan tu inflamación de las 24 horas. Estos son los 3 pasos que reordenan tu curva hormonal completa.',
    blocks: [
      {
        subtitle: 'La Tríada de Poder',
        items: [
          'Luz solar directa (5 min): sincroniza tu ritmo circadiano. Sin esto, el cortisol no tiene referencia temporal.',
          'Suero adrenal (agua + sal celta): nutre tus glándulas suprarrenales agotadas. Una pizca de sal es la diferencia entre retención y drenaje.',
          'Proteína antes que café: nunca café en ayunas. La cafeína en estómago vacío dispara el cortisol.',
        ],
      },
    ],
  },
  {
    label: 'Capítulo 4',
    kicker: 'La nutrición de calma',
    title: 'Nutrición de Rescate (Nutrientes de Calma)',
    description:
      'No contaremos calorías (eso estresa). Contaremos mensajes bioquímicos: aprenderás qué alimentos apagan la alarma y cuáles la disparan.',
    blocks: [
      {
        subtitle: 'Alimentos que apagan la alarma',
        items: [
          'Potasio (aguacate, plátano): regula el sodio',
          'Magnesio (semillas, espinaca): relaja el sistema nervioso',
          'Grasas estables (coco, mantequilla): regulan el cortisol',
          'Proteína de calidad: estabiliza la glucosa',
        ],
      },
      {
        subtitle: 'Disparadores de alarma que eliminas',
        items: [
          'Aceites de semillas (inflamatorios)',
          'Edulcorantes artificiales (confunden al cerebro)',
          'Harinas refinadas (suben la glucosa bruscamente)',
        ],
      },
    ],
  },
  {
    label: 'Capítulo 5',
    kicker: 'El movimiento de seguridad',
    title: 'Entrenar sin estresar',
    description:
      'Aquí cambia todo. El HIIT, el CrossFit y el cardio intenso son tu enemigo temporal. En su lugar trabajamos con movimiento que baja la alarma.',
    blocks: [
      {
        subtitle: 'Lo que sí haces',
        items: [
          'Caminatas lentas en la naturaleza',
          'Yoga restaurativo',
          'Fuerza de bajas repeticiones con mucho descanso',
        ],
      },
    ],
    note: 'La regla de oro: si terminas “destruida”, subiste tu cortisol. Si terminas energizada, lo bajaste.',
  },
  {
    label: 'Capítulo 6',
    kicker: 'El interruptor nocturno',
    title: 'Reset del Sistema Nervioso',
    description:
      'Si tu mente no para, tu cuerpo no drena. Este capítulo te da el ritual exacto para entrar en sueño profundo.',
    blocks: [
      {
        subtitle: 'El ritual de las noches',
        items: [
          'Brain dump (vaciado mental): escribe cada pendiente antes de dormir. Si está en el papel, el cerebro deja de vigilarlo.',
          'Respiración vagal: inhala en 4, exhala en 8. La exhalación larga es el botón de apagado del cortisol.',
          'Magnesio glicinato: el suplemento que abre la puerta al sueño profundo.',
        ],
      },
    ],
  },
  {
    label: 'Capítulo 7',
    kicker: 'El blindaje permanente',
    title: 'Cómo la inflamación no regresa',
    description:
      'Los 7 días fueron el reset. Ahora necesitas un sistema de mantenimiento para que el estrés no te vuelva a secuestrar.',
    blocks: [
      {
        subtitle: 'Tu sistema de mantenimiento',
        items: [
          'Las 3 reglas no-negociables para mantener los resultados',
          'Cómo detectar cuándo estás entrando de nuevo en Estado de Supervivencia',
          'El protocolo de rescate rápido para días de mucho estrés',
        ],
      },
    ],
  },
  {
    label: 'Incluido',
    kicker: 'Checklist de 7 días',
    title: 'Tu mapa paso a paso, sin pensar, sin fallar',
    description: 'Cada día tiene su tarea. Solo tienes que marcarlas.',
  },
]
